import { Location } from 'vue-router';
import {
  BillItemFields,
  BlMetaDataInput,
  ChannelTypeEnum,
  fetchInquiry_inquiries_arrivalPlace,
  fetchInquiry_inquiries_departurePlace,
  fetchShippers_shippers,
  InquiryFields,
  OperatorFields,
  ShipmentOrderEnum
} from '@/types/graphql/schemaTypes';

export interface Alert {
  message: string;
  time?: number; // time in millisecond
  type: 'info' | 'success' | 'warning' | 'error';
}

export interface BlInformations {
  blMetaData?: BlMetaDataInput | null;
}

export interface BooleanTranslationType {
  true?: string;
  false?: string;
  default?: string;
}

export interface CalloutOption<T> {
  event: string;
  eventArgs?: T;
  cssClass?: string;
  label: string;
}

export interface CheckboxStatus {
  checked?: boolean;
  indeterminate?: boolean;
}

// @FIXME after unify Customer's company and Shipment's Parties
// tslint:disable-next-line
export type Company = fetchShippers_shippers

export interface ConfirmationData{
  color?: string;
  confirmLabel?: string;
  dispatch?: string;
  mutation?: string;
  options?: {
    color?: string;
    confirmLabel?: string;
    modalContent?: string;
    titleLabel?: string;
  };
  payload: any;
  titleLabel?: string;
}

export interface ContainerDetails {
  axel?: number;
  containerNumber?: string;
  id?: string;
  scale?: boolean;
  sealNumber?: string;
  size?: string;
  tareWeight?: number;
  virtualContainer?: boolean;
  weightUnit?: string;
}

export interface CustomerLocationOption<T> extends SelectOption<T> {
  combinedAddress?: string;
}

export interface CustomsInformations {
  blMetaData?: BlMetaDataInput | null;
  invoiceNumber?: string | null;
  shippingMarks?: string | null;
}

export interface DateOptionTypes {
  format?: string;
  localTime?: boolean;
}

export enum DelegatedStepsEnum {
  container_drayage = 'container_drayage',
  export_customs_clearance = 'export_customs_clearance',
  import_customs_clearance = 'import_customs_clearance',
  truck_delivery = 'truck_delivery',
}

export interface ElAutocomplete<T> {
  value: string;
  item: T;
}

// For channel types, we need both GQL types and FE specific types
// 1. So we create the FE specific enum
export enum FrontChannelTypeEnum {
  creation = 'creation'
}

export enum FileOptionsEnum {
  an = 'an',
  bl = 'bl',
  customsPermit = 'customs_permit',
  insurance = 'insurance',
  co = 'co',
  invoice = 'invoice',
  packingList = 'packing_list'
}

export interface InquiryFilterType {
  customerFilter: string | null;
  operatorFilter: string;
  status: string;
}

export interface InstantQuoteItem {
  billItems: BillItemFields[];
  inquiry: InquiryFields;
}

export interface InsuranceFormElement extends HTMLElement{
  dataForSaving: Function;
  loadSavedData: Function;
}

export interface HsCode {
  code: string;
  country: string;
}

// 2. We export both enums as one type
// (because there is no such things as extends for enums)
export type MixedChannelTypeEnum = ChannelTypeEnum | FrontChannelTypeEnum

export interface NavBarShipment {
  arrivalPlace?: fetchInquiry_inquiries_arrivalPlace | null;
  assignedOperator: OperatorFields | null;
  departurePlace?: fetchInquiry_inquiries_departurePlace | null;
  id: string;
  reference: string;
  shipper: fetchShippers_shippers;
}

export interface NavigationSection extends Location {
  i18nKey: string;
}

export interface PaymentInformations {
  id?: string;
  incoterm?: string;
  paymentAsArranged?: boolean;
  paymentPlace?: string;
  paymentTerms?: string;
}

export interface RouteInput {
  arrivalAddress?: any | null;
  arrivalPlaceId: string | null;
  departureAddress?: any | null;
  departurePlaceId: string | null;
}

export interface SelectOption<T> {
  id?: string;
  isCreation?: boolean;
  label: string;
  value?: T | null;
}

export enum ShipmentListOrderEnum {
  customs_clearance_asc = ShipmentOrderEnum.customs_clearance_asc,
  import_arrival_export_delivery_asc = ShipmentOrderEnum.import_arrival_export_delivery_asc,
  import_delivery_export_collection_asc = ShipmentOrderEnum.import_delivery_export_collection_asc,
  updated_at = ShipmentOrderEnum.updated_at
}

export interface ShipmentRouteOptions {
  arrivalPort?: string | null;
  departurePort?: string | null;
  incoterms?: string | null;
}

export interface StakeHolderDetails {
  email?: string;
  faxNumber?: string;
  fullAddress?: string;
  id?: string;
  name?: string;
  phoneNumber?: string;
}
